module.exports = __webpack_public_path__ + "img/ep-N.c4a50d96.jpg";